/* preventa.js — los productos que se venden ANTES de existir.

   Alfredo, 2026-08-19: *"quiero agregar productos en preventa, que aparezca una alerta en el
   producto como la de descuento que diga preventa. Al agregar ese producto lanzar un alertdialog
   donde indican que aceptan los términos y condiciones, los cuales indicarán que es una preventa
   y que empezará el proceso de envío dentro de cierta fecha."*

   Una preventa es COBRAR HOY por algo que no se manda hoy. Si eso no queda dicho y aceptado antes
   de pagar, la diferencia entre «preventa» y «retraso» la pone la clienta, y la pone en un
   reclamo. Por eso la aceptación no es un adorno: se pide, y queda pegada a SU línea del pedido
   (`properties[Preventa]`), que es donde Alfredo la va a ver al preparar el paquete.

   La lista de productos NO vive aquí: la manda la app. Es la lección del umbral del envío gratis
   —el mismo dato en dos sitios acaba diciendo cosas distintas, y la copia que ve la clienta es la
   que nadie recuerda cambiar—. Este archivo pregunta; no guarda.

   Si la app no contesta, no pasa nada malo: no hay insignias y no hay diálogo. Una tienda que no
   puede vender porque un servicio no respondió es peor que una preventa sin aviso; y el aviso
   vuelve solo en cuanto la app conteste. */
(function () {
  // El MISMO endpoint que usa `carrito.js`. Escrito aquí también y no leído de allí porque cada
  // archivo del tema se carga por su cuenta: importar una variable de otro sería atarlos en un
  // orden que el navegador no garantiza.
  var APP = 'https://envios-bakabaka.fly.dev';
  var CACHE = 'bkb_preventa';
  var PV = null;

  // Se expone para que `carrito.js` —que es quien manda al carrito— pueda preguntar antes de
  // agregar. Dos interceptores del mismo `submit` es cómo uno agrega y el otro cree que no.
  window.BKB_PREVENTA = {
    // ¿Este handle es de preventa? Devuelve la plantilla, o null.
    de: function (handle) {
      if (!PV || !PV.activo || !handle || !enVentana()) return null;
      return (PV.productos || []).indexOf(String(handle)) >= 0 ? PV : null;
    },
    // El handle del producto de un formulario de agregar. Dos caminos porque hay dos sitios:
    // la rejilla y la vista rápida lo llevan en un contenedor con `data-handle`; la página del
    // producto no tiene ese contenedor, pero SÍ lo lleva en la URL.
    handleDe: function (form) {
      var c = form && form.closest && form.closest('[data-handle]');
      if (c && c.getAttribute('data-handle')) return c.getAttribute('data-handle');
      var m = String(location.pathname || '').match(/\/products\/([^/?#]+)/);
      return m ? decodeURIComponent(m[1]) : '';
    },
    preguntar: preguntar
  };

  /* ¿HOY se vende en preventa? Alfredo, 2026-08-19: *"la preventa debe de tener un empieza en y
     termina en; después de eso la preventa termina y si hay stock puede seguir el producto como
     producto normal"*.

     El servidor ya manda `vigente` calculado, pero esta respuesta se guarda en la sesión del
     navegador: una pestaña abierta desde ayer seguiría vendiendo en preventa lo que ya terminó.
     Así que se vuelve a comprobar aquí, con las fechas, cada vez que se pregunta. */
  function enVentana() {
    if (!PV) return false;
    var hoy = new Date().toISOString().slice(0, 10);
    var desde = String(PV.desde || ''), hasta = String(PV.hasta_efectivo || PV.fecha || '');
    if (desde && hoy < desde) return false;
    if (hasta && hoy > hasta) return false;
    return true;
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* EL DIÁLOGO. Devuelve una promesa: `true` si aceptó. El botón nace APAGADO y lo enciende la
     casilla — un diálogo que se cierra dándole a «aceptar» sin marcar nada no prueba nada, y lo
     que se está probando aquí es que ella supo lo que compraba. */
  function preguntar(pv) {
    return new Promise(function (listo) {
      var v = document.createElement('div');
      v.className = 'pv-velo';
      v.setAttribute('role', 'presentation');
      // DOS DATOS, DOS RENGLONES, CON SU ICONO. Alfredo, 2026-08-20: *"quiero que se vea más
      // estético el texto y más resumido"*. Antes era un párrafo largo que repetía tres veces lo
      // mismo; lo que ella necesita saber son dos cosas —cuándo se lanza y cuánto tarda en salir—
      // y cada una se lee de un vistazo si va sola.
      var _lz = pv.lanzamiento || pv.aviso_envio || '';
      var _sl = pv.salida || '';
      v.innerHTML =
        '<div class="pv-caja" role="alertdialog" aria-modal="true" aria-labelledby="pvTit">'
        + '<h2 id="pvTit">' + esc(pv.titulo || 'Este producto es de preventa') + '</h2>'
        + (_lz ? '<div class="pv-dato"><span class="pv-ico">📅</span>' + esc(_lz) + '</div>' : '')
        + (_sl ? '<div class="pv-dato"><span class="pv-ico">📦</span>' + esc(_sl) + '</div>' : '')
        + (pv.texto ? '<p class="pv-texto">' + esc(pv.texto) + '</p>' : '')
        // UN AVISO, NO UN CONTRATO. Alfredo, 2026-08-20: *"que se sienta más como una alerta
        // que como términos y condiciones"*. La casilla se queda —es la prueba de que lo supo—
        // pero dicha como se lo diría una persona. Quien está a un clic de comprar y ve letra
        // legal no la lee: se va. Y aquí no hace falta una firma, hace falta que ENTIENDA.
        + '<label class="pv-acepto"><input type="checkbox" id="pvOk">'
        + '<span>De acuerdo, lo espero</span></label>'
        + '<div class="pv-pie"><button type="button" class="pv-no">Mejor no</button>'
        + '<button type="button" class="pv-si" disabled>Sí, lo aparto</button></div></div>';
      document.body.appendChild(v);
      var caja = v.querySelector('.pv-caja');
      var ok = v.querySelector('#pvOk'), si = v.querySelector('.pv-si'), no = v.querySelector('.pv-no');
      ok.addEventListener('change', function () { si.disabled = !ok.checked; });
      function cerrar(r) {
        document.removeEventListener('keydown', tecla, true);
        v.remove();
        listo(r);
      }
      function tecla(ev) { if (ev.key === 'Escape') { ev.stopPropagation(); cerrar(false); } }
      document.addEventListener('keydown', tecla, true);
      si.addEventListener('click', function () { if (ok.checked) cerrar(true); });
      no.addEventListener('click', function () { cerrar(false); });
      // Tocar fuera CANCELA, no acepta: ante la duda, no se compra.
      v.addEventListener('click', function (ev) { if (ev.target === v) cerrar(false); });
      // El foco entra en el diálogo; si no, el lector de pantalla sigue leyendo la página de
      // detrás y quien navega con teclado no encuentra la casilla.
      (caja.querySelector('#pvOk') || caja).focus();
    });
  }

  /* LA BANDA. Se pone desde aquí y no en Liquid porque la lista la decide la app: meterla en un
     ajuste del tema sería la segunda copia del mismo dato. Se vuelve a pasar cuando llegan
     tarjetas nuevas (la rejilla carga más al bajar, y la vista rápida se abre después).

     Alfredo, 2026-08-19: *"el icono de preventa compite con espacio de ancho con el de descuento,
     debe de poder visualizarse mejor, pero sin tapar la fotografía del producto"*. Por eso va
     DEBAJO de la foto y no encima: sobre la imagen ya viven el «-20%» y el «agotado», y la
     fotografía es lo que la clienta vino a ver. */
  function marcar(raiz) {
    if (!PV || !PV.activo || !enVentana()) return;
    var nodos = (raiz || document).querySelectorAll('[data-handle]');
    for (var i = 0; i < nodos.length; i++) {
      var n = nodos[i], h = n.getAttribute('data-handle');
      if (!h || (PV.productos || []).indexOf(h) < 0) continue;
      if (n.querySelector('.marca-preventa')) continue;
      var s = document.createElement('span');
      s.className = 'marca-preventa';
      // SOLO LA PALABRA. Alfredo, 2026-08-19: *"solo quiero que el icono diga preventa"*. La
      // fecha se dice donde de verdad importa —en el aviso que ella acepta al agregarlo—, no en
      // una tarjeta que se mira de reojo mientras se baja por la rejilla.
      s.textContent = PV.insignia || 'Preventa';
      // DEBAJO DE LA FOTO. Si no se encuentra la imagen —otra plantilla, otro tema— se pone al
      // principio, que es peor sitio pero nunca deja el aviso fuera de la tarjeta.
      var foto = n.querySelector('.tarjeta-imagen, .vr-media');
      if (foto && foto.parentNode === n) n.insertBefore(s, foto.nextSibling);
      else n.insertBefore(s, n.firstChild);
    }
  }

  function aplica(pv) {
    PV = pv || null;
    // Fuera de la ventana el producto es un producto NORMAL: ni insignia, ni diálogo, ni nada
    // que recuerde que un día se vendió por adelantado.
    if (!PV || !PV.activo || !enVentana()) return;
    marcar(document);
    // Lo que llega después: más tarjetas al bajar, la vista rápida al abrirse.
    if (window.MutationObserver) {
      new MutationObserver(function (ms) {
        for (var i = 0; i < ms.length; i++) {
          for (var j = 0; j < ms[i].addedNodes.length; j++) {
            var n = ms[i].addedNodes[j];
            if (n.nodeType === 1) marcar(n.matches && n.matches('[data-handle]') ? n.parentNode : n);
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (!APP) return;                       // sin app no hay lista: la tienda sigue igual que siempre
  var guardado = null;
  try { guardado = JSON.parse(sessionStorage.getItem(CACHE) || 'null'); } catch (e) { guardado = null; }
  if (guardado) { aplica(guardado); return; }
  fetch(APP + '/puente')
    .then(function (r) { return r.json(); })
    .then(function (c) {
      if (!c || !c.preventa) return;
      try { sessionStorage.setItem(CACHE, JSON.stringify(c.preventa)); } catch (e) { /* privado */ }
      aplica(c.preventa);
    })
    .catch(function () { /* sin app: ni insignia ni diálogo, y la tienda vende igual */ });
})();
